import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { ListingCard } from "@components/Pages";
import { NothingFilteredAlert, PaymentsSummary, PaymentsTable } from "@components/Statistics";
import { url_reverse } from "@components/Utils";

export default function StatisticsPayments({ developerId, header }) {
    const { t } = useTranslation();
    const params = useParams();
    const { apiData } = useAppApi(
        url_reverse("api:developer:statistics:payments", { developer_id: developerId, kind: params.kind })
    );

    if (!apiData) return;

    const headerTools = apiData.object_list?.length > 0 && (
        <ExportButton size="sm" prms={{ "filter-stats_period": apiData.forms_data.filter.data.stats_period }} />
    );

    return (
        <ListingCard header={header} headerTools={headerTools} filterComponent={false}>
            <RenderForm prefix="filter" submitButtonText={t("Построить")} submitMethod="get" />
            <PaymentsSummary />
            <NothingFilteredAlert />
            <PaymentsTable />
        </ListingCard>
    );
}
